import { twMerge } from "tailwind-merge";
interface ClpHeaderProps {
  title: string;
  description: string;
  customClass?: string;
  descriptionCustomClass?: string;
}

const ClpHeader = ({
  title,
  description,
  customClass,
  descriptionCustomClass,
}: ClpHeaderProps) => {
  return (
    <section
      className={twMerge("flex flex-col gap-[4px] px-[16px] py-[12px]", customClass)}
    >
      <h1 className="font-medium font-rubik ipo-title text-[18px] md:text-[20px] leading-none  text-[#1A1A1A]" >{title}</h1>
      <p
        className={twMerge(
          "sign-in-text text-[12px] md:text-[14px] md:leading-[20px] align-middle text-gray-600",
          descriptionCustomClass,
        )}
      >
        {description}
      </p>
    </section>
  );
};

export default ClpHeader;